import { defineMessages } from 'react-intl';

export default defineMessages({
  loginHeadTitle: {
    id: 'mf.login.head.title',
    defaultMessage: 'Continue with multi-factor authentication',
    description: '',
  },

  // Flags
  mfRecoveryEmailResentSuccessTitle: {
    id: 'mf.recoveryemailresentsuccess.title',
    defaultMessage: 'Recovery email resent!',
    description: '',
  },
  mfRecoveryEmailResentSuccessDesc: {
    id: 'mf.recoveryemailresentsuccess',
    defaultMessage: 'A recovery email has been resent to you!',
    description: '',
  },
  mfRecoveryEmailResentErrorTitle: {
    id: 'mf.recoveryemailresenterror.title',
    defaultMessage: 'Something went wrong.',
    description: '',
  },
  mfRecoveryEmailResentErrorDesc: {
    id: 'mf.recoveryemailresenterror',
    defaultMessage: 'We couldn’t send the recovery email. Please try again later.',
    description: '',
  },
  mfRecoverySMSResentSuccessTitle: {
    id: 'mf.recoverysmsresentsuccess.title',
    defaultMessage: 'SMS resent!',
    description: '',
  },
  mfRecoverySMSResentSuccessDesc: {
    id: 'mf.recoverysmsresentsuccess',
    defaultMessage: 'A SMS has been resent to you!',
    description: '',
  },
  mfEmailResentSuccessTitle: {
    id: 'mf.emailresentsuccess.title',
    defaultMessage: 'Email resent!',
    description: '',
  },
  mfEmailResentSuccessDesc: {
    id: 'mf.emailresentsuccess',
    defaultMessage: 'An Email has been resent to you!',
    description: '',
  },
  mfVerifyErrorTitle: {
    id: 'guardian.error.default.flag.title',
    defaultMessage: "Oops, that didn't work!",
  },
  mfVerifyErrorDesc: {
    id: 'guardian.error.default.flag.description',
    defaultMessage: 'Try that again in a moment.',
  },
  // eg. if Twilio deprecates service in the country
  mfSmsInvalidPhoneNumberDesc: {
    id: 'mf.sms.invalidphonenumber.description',
    defaultMessage:
      'Unable to send verification code to the registered phone number. Try again later, or navigate to the recovery code screen and use your recovery code to continue.',
  },
  mfSwitchToSms: {
    id: 'mf.switch-to.sms',
    defaultMessage: 'Use SMS',
    description: 'Button text to switch to SMS verification',
  },
  mfSwitchToTotp: {
    id: 'mf.switch-to.authenticator',
    defaultMessage: 'Use authenticator app',
    description: 'Button text to switch to authenticator verification',
  },
  mfSwitchToSecurityKey: {
    id: 'mf.switch-to.security.key',
    defaultMessage: 'Use security key',
    description: 'Button text to switch to security key verification',
  },
  mfSwitchFactorInvalidFactorTypeTitle: {
    id: 'mf.switch-factor.invalid-factor-type.title',
    defaultMessage: 'Invalid method',
    description: 'Title for invalid factor type error when switching MFA factors',
  },
  mfSwitchFactorInvalidFactorTypeDesc: {
    id: 'mf.switch-factor.invalid-factor-type.description',
    defaultMessage: 'The selected verification method is not supported. Try a different option.',
    description: 'Description for invalid factor type error when switching MFA factors',
  },
  mfSwitchFactorInvalidTokenTitle: {
    id: 'mf.switch-factor.invalid-transaction-token.title',
    defaultMessage: 'Invalid request',
    description: 'Title for invalid transaction token error when switching MFA factors',
  },
  mfSwitchFactorInvalidTokenDesc: {
    id: 'mf.switch-factor.invalid-transaction-token.description',
    defaultMessage: 'Your request cannot be processed.',
    description: 'Description for invalid token error when switching MFA factors',
  },
  mfSwitchFactorTransactionExpiredTitle: {
    id: 'mf.switch-factor.expired_transaction_token.title',
    defaultMessage: 'Request expired',
    description: 'Title for expired transaction error when switching MFA factors',
  },
  mfSwitchFactorTransactionExpiredDesc: {
    id: 'mf.switch-factor.expired-transaction-token.description',
    defaultMessage: 'Your login request has expired',
    description: 'Description for expired transaction when switching MFA factors',
  },
  mfSwitchFactorTooManyAttemptsTitle: {
    id: 'mf.switch-factor.too-many-attempts.title',
    defaultMessage: 'Too many requests',
    description: 'Title for reaching rate limit when switching MFA factors',
  },
  mfSwitchFactorTooManyAttemptsDesc: {
    id: 'mf.switch-factor.too-many-attempts.description',
    defaultMessage: "You've reached your rate limit. Try again in a few minutes.",
    description: 'Description for reaching rate limit when switching MFA factors',
  },
  mfSwitchFactorErrorTitle: {
    id: 'mf.switch-factor.error.title',
    defaultMessage: 'Unable to change method',
    description: 'Title for generic factor switching error',
  },
  mfSwitchFactorErrorDesc: {
    id: 'mf.switch-factor.error.description',
    defaultMessage:
      'We encountered an issue while changing your verification method. Try again later.',
    description: 'Description for generic factor switching error',
  },
  // recovery code
  mfSwitchToRecoveryCode: {
    id: 'mf.switch-to.recovery-code',
    defaultMessage: 'Use recovery key',
    description: 'Button text to switch to solving MFA challenge with recovery key',
  },
});
